import { useEffect } from 'react';

import { Form, type Location, useLocation, useNavigate, useNavigation } from 'react-router';

import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { isDefined } from '@enterprise/core';
import { Microsoft, useLoadingStore } from '@enterprise/ui';

import { useApplicationStore } from '@hooks/application/application-store.hook';

import type { LoginState } from './types/login-state.type';

const Login = () => {
  const user = useApplicationStore(({ user }) => {
    return user;
  });

  const { setIsLoading } = useLoadingStore();
  const location = useLocation() as Location<LoginState | undefined>;
  const navigate = useNavigate();
  const navigation = useNavigation();
  const returnTo = location.state?.returnTo;

  useEffect(() => {
    if (isDefined(user)) {
      void navigate(returnTo ?? '/datastream');
    }
  }, [navigate, returnTo, user]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: only run on mount
  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <Form method="post">
      {isDefined(returnTo) && (
        <input
          name="returnTo"
          type="hidden"
          value={returnTo}
        />
      )}
      <Flex
        bg="hsp.500"
        className="h-screen w-screen">
        <Box
          className="hidden h-full grow-[2] basis-0 flex-col justify-center sm:flex"
          p={8}>
          <Text
            as="b"
            color="white"
            fontSize="4xl">
            HSP Direct
          </Text>
          <Text
            color="white"
            fontSize="2xl">
            The data behind your ROI
          </Text>
        </Box>
        <Flex
          alignItems="center"
          bg="white"
          className="sm:rounded-l-lg"
          direction="column"
          flexBasis={0}
          grow={1}
          h="full"
          justifyContent="center"
          p={8}
          textAlign="center">
          <Text
            as="b"
            fontSize="3xl"
            mb={5}>
            Log in to your account
          </Text>
          <Button
            alignItems="center"
            colorScheme="hsp"
            disabled={navigation.state === 'submitting'}
            display="flex"
            gap={1}
            isLoading={navigation.state === 'submitting'}
            leftIcon={
              <Microsoft
                fixedWidth
                size="lg"
              />
            }
            loadingText="Connecting to Microsoft"
            size="lg"
            type="submit">
            Sign in with Microsoft
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
};

export default Login;
